module.exports = __webpack_public_path__ + "img/1604.d3ef56ea.png";